import en from './en';
import id from './id';
import { useTranslate, setLangStorage, getLangStorage } from './LangGenerator';

export { en, id, useTranslate, setLangStorage, getLangStorage };
